export const Appointment = '/Appointments'
export const EditAppointment = '/Appointments/edit/:id'
export const AppointmentReport = '/Appointments/report'
